// Secrets that have just been generated and are waiting to be shown.
//
// An API key or a documentation password is shown once and exists nowhere else afterwards (the API keeps
// only a hash). Two can be issued close together: the administrator clicks "Générer la clé", then
// ticks "Accès à la documentation" while the first request is still running. A single slot would let
// the second answer silently replace the first, whose secret would then be lost without ever having
// been seen. The client sheet therefore keeps a first-in, first-out queue and shows one secret at a
// time: the next one appears only once the current one has been closed (which the modal allows only
// after the copy has been confirmed).

/**
 * The queue with a secret added behind the ones already waiting. A secret that is already queued
 * (same id) is not added again, so a response handled twice cannot show the same secret twice.
 *
 * @param {Array<{ id: string }>} queue - Secrets waiting, the first one being the one on screen
 * @param {{ id: string }} secret - The secret that has just been issued
 */
export const enqueueSecret = (queue, secret) =>
  queue.some((item) => item.id === secret.id) ? queue : [...queue, secret];

/**
 * The queue without its first secret, which has just been closed. The next one, if any, comes
 * forward.
 *
 * @param {Array<{ id: string }>} queue
 */
export const dequeueSecret = (queue) => queue.slice(1);
